import {
    ChangeDetectionStrategy,
    Component,
    computed,
    inject,
    signal,
} from '@angular/core';
import {
    ConfigurationService,
    MobileAppService,
} from '@interacta-shared/data-access-configuration';
import { ButtonComponent } from '@interacta-shared/ui';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'interacta-mobile-banner',
    templateUrl: './mobile-banner.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [ButtonComponent, TranslatePipe],
})
export class MobileBannerComponent {
    private readonly configService = inject(ConfigurationService);
    protected readonly mobileAppService = inject(MobileAppService);

    readonly dismissed = signal(false);
    readonly isMobile = this.mobileAppService.isMobile();

    readonly spidEnabled = computed(
        () =>
            this.configService.environmentInfo()?.installedFeatures
                ?.spidLogin ?? false,
    );
    readonly show = computed(
        () =>
            this.isMobile &&
            !this.dismissed() &&
            !!this.configService.environmentInfo(),
    );

    dismiss(): void {
        this.dismissed.set(true);
    }
}
